import { actionPayload } from "@App/userHistoryReducer";
import { getPaymentFullUrl } from "@Components/LeadForm/utils";
import getParsedLocalStorageData from "@Components/LeadFormModal/helpers/getParsedLocalStorageData";
import getSelectedRoomAndTenancy from "./getSelectedRoomAndTenancy";

const getPaymentFormLink = ({
  rooms,
  id,
  canonicalName,
  payment_initiated,
  nationality,
  isPaymentBeforeBookform,
  source,
}: {
  rooms: any;
  id: number;
  canonicalName: string;
  payment_initiated?: actionPayload | null;
  nationality?: string;
  isPaymentBeforeBookform?: boolean;
  source?: string;
}) => {
  const lfOneSuccessData: any = getParsedLocalStorageData("lead-form-one-success-data");
  const bookFormData: any = getParsedLocalStorageData("BOOK_FORM");
  const { selectedRoom, selectedTenancy } = getSelectedRoomAndTenancy({ rooms, id });

  const bookform_arrival_date =
    bookFormData.inventory_id === id && bookFormData.arrival_date
      ? new Date(bookFormData.arrival_date).toISOString().split("T")[0]
      : null;
  const payment_initiated_arrival_date =
    payment_initiated && payment_initiated.arrival_date ? payment_initiated.arrival_date : null;

  const book_form_custom_duration =
    bookFormData.inventory_id === id && bookFormData.custom_duration
      ? bookFormData.custom_duration.split(" ")[0]
      : null;
  const payment_initiated_custom_duration =
    payment_initiated && payment_initiated.custom_duration
      ? payment_initiated.custom_duration
      : null;

  const options: any = {};

  if (selectedRoom || selectedTenancy) {
    if (bookform_arrival_date || payment_initiated_arrival_date) {
      options.arrival_date = bookform_arrival_date || payment_initiated_arrival_date;
    }
    if (selectedTenancy) {
      options.inventory_id = selectedTenancy.meta?.available_from_formatted
        ? selectedTenancy.id
        : `${selectedRoom.id}${selectedTenancy.id}`;
      options.lease_duration = `${selectedTenancy.meta.lease_duration} ${selectedTenancy.meta.lease_duration_unit}`;
      options.room_id = selectedRoom.id;
      options.tenancy_id = selectedTenancy.id;
    } else {
      // todo - if lead is filled against room (where it does not have any tenancies), it will always
      // a flexible
      // options.inventory_id = 'flexible;
      options.inventory_id = selectedRoom?.id;
      options.lease_duration = "flexible";
      options.room_id = selectedRoom.id;
      if (book_form_custom_duration || payment_initiated_custom_duration) {
        options.custom_duration = book_form_custom_duration || payment_initiated_custom_duration;
      }
    }
    options.config_name = selectedRoom?.name;
  } else if (payment_initiated) {
    const { id: currId, config_name, config_id, level, meta } = payment_initiated;

    if (level === "tenancy") {
      options.inventory_id = meta?.available_from_formatted ? currId : `${config_id}${currId}`;
      options.room_id = config_id;
      options.tenancy_id = currId;
      options.lease_duration = `${meta?.lease_duration} ${meta?.lease_duration_unit}`;
      if (bookform_arrival_date || payment_initiated_arrival_date)
        options.arrival_date = bookform_arrival_date || payment_initiated_arrival_date;
    } else {
      options.inventory_id = currId;
      options.room_id = currId;
      options.lease_duration = "flexible";
      if (book_form_custom_duration || payment_initiated_custom_duration)
        options.custom_duration = book_form_custom_duration || payment_initiated_custom_duration;
      if (bookform_arrival_date || payment_initiated_arrival_date)
        options.arrival_date = bookform_arrival_date || payment_initiated_arrival_date;
    }
    options.config_name = config_name;
  }

  if (Object.keys(lfOneSuccessData).length) {
    options.lead_id = lfOneSuccessData.id;
    if (lfOneSuccessData.uuid) options.lead_uuid = lfOneSuccessData.uuid;
    options.email = lfOneSuccessData.user_details.email;
    if (lfOneSuccessData?.user_details?.name) options.name = lfOneSuccessData.user_details.name;

    if (lfOneSuccessData?.user_details?.phone_details) {
      options.phone = JSON.stringify({
        country_code: lfOneSuccessData.user_details.phone_details.country_code,
        international: lfOneSuccessData.user_details.phone_details.international,
      });
    }
  }

  // for nationality based payment
  if (nationality || (Object.keys(bookFormData).length > 0 && bookFormData["data/nationality"])) {
    options.nationality = nationality || bookFormData["data/nationality"];
  }
  if (isPaymentBeforeBookform) {
    options.payment_before_bookform = true;
  }
  if (source) options.payment_source = source;
  options.isHappyFlow = true;

  return getPaymentFullUrl(canonicalName, options);
};

export default getPaymentFormLink;
